import { recordsRepo } from "./records.repo";
import {
  IDrustvoAktivniObjektiProps,
  TrademarkListPayload,
} from "./records.types";

class RecordsService {
  createDrustvoAktivniObjekti = () => {
    return recordsRepo.createDrustvoAktivniObjekti();
  };

  getAllTrademarks = (payload: TrademarkListPayload) => {
    return recordsRepo.getAllTrademarks(payload);
  };

  getDrustvoAktivniObjektiOptions = (
    filters: IDrustvoAktivniObjektiProps[]
  ) => {
    const newFilters = filters?.map((option: IDrustvoAktivniObjektiProps) => {
      return {
        label: `${option.naziv} - ${option.ulicaIBroj}`,
        value: option.id,
      };
    });
    return newFilters;
  };
}

export const recordsService = new RecordsService();
